<script>
    import { createEventDispatcher, onDestroy, onMount } from 'svelte';
    import { Rive, Layout, Fit, Alignment, EventType } from '@rive-app/canvas';
    import { RIVE_ANIMATIONS, changeValueOfAnimationText, getAnimationParams } from '@src/utils/animations.js';
    import { EventEmitterInstance } from '@root/src/utils/event-emitter';
    import { playAudio } from '@root/src/utils/audio';

    export let multipliersLeft = [];
    export let selectedLeftMultiplier = null;
    export let multiplierRight = [];
    export let selectedRightMultiplier = null;
    const stateMachineName = 'State Machine 1';
    const artboardName = 'crazy_top_slot';
    const startTrigger = 'start';
    const bonusTrigger = 'bonus_mult';
    const rightSlot1 = 'right_slot1';
    const rightSlot2 = 'right_slot2';
    const rightSlot3 = 'right_slot3';
    const customDPR = 1;
    const dispatch = createEventDispatcher();

    let topSlotRiveInstance;
    let animationParams;
    let sound;
    let timer;

    let timerLeft;
    let timerRight;

    const setTextLeftMultiplier = (arr, needMultiplier) => {
        const selectedLeftMultiplier = arr?.filter(multiplier => multiplier === needMultiplier);

        changeValueOfAnimationText(topSlotRiveInstance.artboard, `text_1_fill`, `×${selectedLeftMultiplier}`);
        changeValueOfAnimationText(topSlotRiveInstance.artboard, `text_1_stroke`, `×${selectedLeftMultiplier}`);

        // for bonus multiplier
        changeValueOfAnimationText(topSlotRiveInstance.artboard, `text_up_fill`, `×${selectedLeftMultiplier}`);
        changeValueOfAnimationText(topSlotRiveInstance.artboard, `text_up_stroke`, `×${selectedLeftMultiplier}`);
    };

    const setRightMultiplier = (arr, needMultiplier, riveParams) => {
        const selectedRightMultiplier = arr?.indexOf(needMultiplier);
        riveParams[rightSlot1].value = selectedRightMultiplier + 1;
    };

    const fireBonusTrigger = () => {
        if (animationParams[bonusTrigger]) animationParams[bonusTrigger].fire();
    };
    const fireStartTrigger = () => {
        if (animationParams[startTrigger]) animationParams[startTrigger].fire();
    };

    const runAnimationTopSlot = canvas => {
        if (topSlotRiveInstance) {
            topSlotRiveInstance.cleanup();
        }

        topSlotRiveInstance = new Rive({
            src: RIVE_ANIMATIONS.TOP_SLOT,
            stateMachines: stateMachineName,
            canvas: canvas,
            autoplay: true,
            artboard: artboardName,
            shouldDisableRiveListeners: false,
            layout: new Layout({
                fit: Fit.Cover,
                alignment: Alignment.Center
            }),
            onLoad: () => {
                topSlotRiveInstance.resizeDrawingSurfaceToCanvas(customDPR);
                animationParams = getAnimationParams(topSlotRiveInstance, stateMachineName, [
                    startTrigger,
                    bonusTrigger,
                    rightSlot1
                ]);

                setTextLeftMultiplier(multipliersLeft, selectedLeftMultiplier);
                setRightMultiplier(multiplierRight, selectedRightMultiplier, animationParams);

                if (timer) {
                    clearTimeout(timer);
                }
                timer = setTimeout(() => {
                    animationParams[startTrigger].fire();
                }, 100);

                EventEmitterInstance.on('top-slot-bonusTrigger', fireBonusTrigger);
                EventEmitterInstance.on('top-slot-startTrigger', fireStartTrigger);
            }
        });

        topSlotRiveInstance.on(EventType.RiveEvent, event => {
            if (event.data?.name === 'start') {
                playAudio('audio_bonus_reels_spin');

                timerLeft = setTimeout(() => {
                    playAudio('audio_bonus_reels_left_stop');
                }, 1500);
                timerRight = setTimeout(() => {
                    playAudio('audio_bonus_reels_right_stop');
                }, 1700);
            }
        });
    };

    onDestroy(() => {
        EventEmitterInstance.removeAllListeners('top-slot-bonusTrigger');
        EventEmitterInstance.removeAllListeners('top-slot-startTrigger');
        topSlotRiveInstance?.cleanup();
        clearTimeout(timerLeft);
        clearTimeout(timerRight);
        clearTimeout(timer);
        sound?.unload();
    });
</script>

<div class="pointer-events-none absolute inset-0 top-[var(--ui-screen-top)] z-[9009] mx-auto h-[176px] max-w-[520px]">
    <canvas class="h-full w-full" width="176" height="500" use:runAnimationTopSlot />
</div>
